import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  useTheme
} from "@mui/material";
import { useNavigate } from "react-router";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Error = () => {
  const [open] = React.useState(true);
  const theme = useTheme();
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/adminlogin");
  };

  return (
    <Modal
      open={open}
      aria-labelledby="fehler-modal-titel"
      aria-describedby="fehler-modal-beschreibung"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor:"#D6B981"
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 500,
          bgcolor: "#F0EAD6",
          borderRadius: theme.shape.borderRadius,
          p: theme.spacing(4),
          outline: "none",
          textAlign: "center"
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 3,
            color: theme.palette.error.main
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 64 }} />
        </Box>

        <Typography
          id="fehler-modal-titel"
          variant="h5"
          component="h2"
          sx={{ 
            mb: 2,
            fontWeight: 700,
            color: theme.palette.error.main
          }}
        >
          Betriebsstörung aufgetreten
        </Typography>

        <Typography
          variant="body1"
          sx={{ 
            mb: 4,
            color: theme.palette.text.secondary,
            fontSize: "1rem"
          }}
        >
          Bitte kehren Sie zum Dashboard zurück, um den Vorgang erneut zu starten.
        </Typography>

        <Button
          variant="contained"
          onClick={handleGoToDashboard}
          size="large"
          sx={{
            backgroundColor: theme.palette.error.main,
            py: 1.8,
            fontSize: "1.1rem",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: theme.palette.error.dark
            }
          }}
        >
          Zum Dashboard zurückkehren
        </Button>
      </Box>
    </Modal>
  );
};

export default Error;